import React from 'react';
import ImageHelp from './imageHelp';
import driverImage from '../../../../assets/images/help/Drivers.png';
import { Card } from 'reactstrap';
import { FaHandPointDown } from 'react-icons/fa';

const DriverHelp = () => {
    return (
        <div className="helpContainer">
            <h2 className="helpTitle">Gestion des Chauffeurs</h2>
            <p className="helpDescription">
                Cette section vous permet de gérer les chauffeurs associés à votre flotte de véhicules. Vous pouvez ajouter, modifier, et supprimer les chauffeurs, ainsi que suivre leurs informations et actions. Découvrez les fonctionnalités ci-dessous pour une gestion optimale de vos chauffeurs :
            </p>

            <div className="helpFeaturesAndImageContainer">
                <div className="helpTextContainer">
                    <ul className="helpFeaturesList">
                        <li><strong>Ajout de chauffeurs :</strong> Enregistrez de nouveaux chauffeurs dans le système, avec leurs informations personnelles et professionnelles.</li>
                        <li><strong>Modification des informations :</strong> Mettez à jour les informations relatives aux chauffeurs, comme l'adresse e-mail, le téléphone et l'adresse.</li>
                        <li><strong>Suppression des chauffeurs :</strong> Supprimez un chauffeur de votre base de données si nécessaire, pour une gestion fluide.</li>
                        <li><strong>Suivi des chauffeurs :</strong> Suivez les détails et l'historique de chaque chauffeur, y compris les inspections effectuées et leur statut.</li>
                        <li><strong>Gestion des rôles :</strong> Définissez les rôles et les autorisations des chauffeurs pour assurer une gestion cohérente et sécurisée.</li>
                    </ul>
                    
                </div>
                <div className="helpImageContainer">
                    <p className="helpBase">
                        Cliquez sur l'image pour la voir en détail.  <FaHandPointDown className="animated-icon" />
                    </p>
                    <Card className='card-animate'>
                        <ImageHelp fileSource={driverImage} width="100%" />
                    </Card>
                </div>
            </div>
            <p className="helpBase">
                Pour plus de détails sur chaque fonctionnalité ou pour obtenir de l'aide supplémentaire, contactez le support technique de Systalink.
            </p>
        </div>
    );
};

export default DriverHelp;
